import { render, staticRenderFns } from "./DialogShowClientsAndEmployees.vue?vue&type=template&id=588c6a3c"
import script from "./DialogShowClientsAndEmployees.vue?vue&type=script&lang=js"
export * from "./DialogShowClientsAndEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports